import { errorToast } from '@/shared/services/helper.js' 
import logoutCleanup from './logoutCleanup';
export default function handlerErrorFromApis(error) {
    if(!error?.response) {
        return Promise.reject([`Error CORS: Check your NETWORK agian and refresh the page.`]);
    };
    const status = error?.response?.status;
    switch (status) {
        case 422:
            if (error.response.data.details) {
                return Promise.reject(`Error ${status}: ${error?.response?.data?.details?.[Object.keys(error?.response?.data?.details)?.[0]]}`);
            } else {
                return Promise.reject([`Error ${status}: ${error?.response?.data?.message}`]);
            }
        case 401:
            errorToast('You Have Been Logged Out From This Device.');
            clearDataOnUnauthorised();
            break;
        case 400:
            let arr = [error?.response.data.message??error?.response.data.msg]
            if(error?.config.url == 'api/login' && (Boolean(error?.response?.data?.alternate_link )|| Boolean(store.getters.siteSettings?.alternate_link))){
                arr.push({alternate_link : error?.response?.data.alternate_link || store.getters.siteSettings?.alternate_link})
            }
            return Promise.reject(arr);
        case 500:
            return Promise.reject([`Error ${status}: ${error?.response?.data?.message ?? error?.response?.data?.msg}`]);
        default:
            return Promise.reject([`Error ${status}: Refresh the page and try again.`]);
    }
}

async function clearDataOnUnauthorised() {
    window.cookies.keys().forEach(cookie => window.cookies.remove(cookie))
    window.store.dispatch('resetAllState');
    await logoutCleanup()
    window.router.push({name:'Home'});
    setTimeout(()=> {
        location.reload();
    }, 100)
}